/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsListReportRunsCatalogQueryResponse, AuditReportsListReportRunsCatalogQueryParams, AuditReportsListReportRunsCatalog401, AuditReportsListReportRunsCatalog403 } from "../models/AuditReportsListReportRunsCatalog";

export function getAuditReportsListReportRunsCatalogUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/report-runs` as const }
  return res
}

/**
 * @description Paginated inbox of async report runs (newest first by default). Uses the shared nestjsx/crudx query DSL (`filter`, `or`, `s`, `sort`, `page`, `limit`, …). Examples: `filter=type||eq||AUDIT_BROADCAST_EVIDENCE`, `filter=metadata.from||eq||2026-09-04`. Always scoped to the current client. Artifacts are always populated. This is not live GIP/BCR execute (`/reports/gip`, `/reports/bcr-matches`). Create a run on the kind path (e.g. POST /report-runs/broadcast-evidence), then poll GET /report-runs/{id}.
 * @summary List report runs for the current client
 * {@link /audit-reports/v1/report-runs}
 */
export async function auditReportsListReportRunsCatalog(params?: AuditReportsListReportRunsCatalogQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsListReportRunsCatalogQueryResponse, ResponseErrorConfig<AuditReportsListReportRunsCatalog401 | AuditReportsListReportRunsCatalog403>, unknown>({ method : "GET", url : getAuditReportsListReportRunsCatalogUrl().url.toString(), params, ... requestConfig })
  return res.data
}